import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import {
  Table,
  Empty,
  Tooltip,
  Col,
  Row,
  Drawer,
  Button,
  Popconfirm, Tabs,
  message,
} from "antd";
import {
  PlusOutlined,
  BarsOutlined,
  DeleteOutlined,
  EditOutlined,
  RollbackOutlined,
  FileExcelOutlined,
} from "@ant-design/icons";
import RequestHandler from "../../util/RequestHandler";
import config from "../../util/ApiforContext";
import FirmAccountAddForm from "../Forms/FirmAccountAddForm";
import FirmAccountUpdate from "../Forms/FirmAccountUpdate";
import { odata } from "../Filters/Helper";
import FirmAccountTableFilter from "../Filters/FirmAccountTableFilter";
import AccountTransactionRuleListFilter from "../Filters/AccountTransactionRuleListFilter";
import {useForm} from "antd/es/form/Form";

const FirmAccountList = (props) => {

  const history = useHistory();
  const [form] = useForm();
  const userId = localStorage.getItem("userId");

  const [tableData, setTableData] = useState({
    data: [],
    total: 0,
    loading: true,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState({
    skip: 0,
    take: 15,
    current: 1,
    filter: "",
    activeTab: 0
  });
  const [order, setOrder] = useState("");

  const [addFormVisible, setAddFormVisible] = useState(false);
  const [updateFormVisible, setUpdateFormVisible] = useState(false);
  const [updateFormData, setUpdateFormData] = useState({});
  const [isSendTosVirmanUnApproved, setIsSendTosVirmanUnApproved] = useState(null);



  const [showBack, setShowBack] = useState(false);



  useEffect(() =>  {
    if(isSendTosVirmanUnApproved != null) {
      getTableData();
    }
  }, [order, tableDataQueryOptions,props, isSendTosVirmanUnApproved]);

  useEffect(() => {
    checkTosRoles();

    const params = new URLSearchParams(window.location.search);
    const showBackQuery = params.get('showBack');

     setShowBack(showBackQuery === 'true');

  }, []);

  const checkTosRoles = () => {
    RequestHandler.get(`/TosAuthorize/CheckTosVirmanUnApproved/${userId}`).then((response) => {
      setIsSendTosVirmanUnApproved(response.data);
    });
  }

  const buildFilterConditions = () => {
    const { filter, activeTab } = tableDataQueryOptions;
    const conditions = [];

    if (props.match.params.firmId) {
      conditions.push(`firmId eq ${props.match.params.firmId}`);
    }

    if (isSendTosVirmanUnApproved) {
      if (activeTab === "1") {
        conditions.push("isTosVirmanAccount eq true");
      } else {
        conditions.push("isTosVirmanAccount eq false");
      }
    }

    if (filter) {
      conditions.push(filter);
    }

    return conditions;
  };

  const getTableData = () => {
    setTableData({
      ...tableData,
      loading: true,
    });

    let query = '';
    const { skip, take } = tableDataQueryOptions;
    const conditions = buildFilterConditions();

    if (conditions.length > 0) {
      query = `&$filter=${conditions.join(" and ")}`;
    }

    RequestHandler.get(
      `/FirmAccount?$count=true${query}${order}&$skip=${skip}&$top=${take}`
    ).then((response) => {
      if (Array.isArray(response.value)) {
        setTableData({
          data: response.value,
          total: response["@odata.count"],
          loading: false,
        });
      }
    });
  };

  const paging = (p, _, sorter) => {
    let orderBy = "";
    if (sorter.columnKey && sorter.order) {
      orderBy =
        "&" +
        (sorter.order === "ascend"
          ? odata.orderBy(sorter.columnKey)
          : odata.orderByDesc(sorter.columnKey));
    }
    setOrder(orderBy);
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const handleOnClickUpdate = (id) => {
    RequestHandler.get(`/FirmAccount/GetById/${id}`).then((response) => {

      if (response) {
        setUpdateFormData(response);
        setUpdateFormVisible(true);
      }
    });
  };

  const handleOnClickDelete = (id) => {
    RequestHandler.delete(`/FirmAccount?id=${id}`).then((response) => {
      if (response.success) {
        getTableData();
      }
    });
  };

  const onAddFormSuccess = () => {
    getTableData();
    setAddFormVisible(false);
  };

  const onUpdateFormSuccess = () => {
    getTableData();
    setUpdateFormVisible(false);
  };

  const onTabChange = (tabKey) => {
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      current: 1,
      activeTab: tabKey,
    });
  };

  const onClickExportExcel = () => {
    const hideMessage = message.loading("Excel indiriliyor...", 0);
    const conditions = buildFilterConditions();
    let query = "";

    if (conditions.length > 0) {
      query = `$filter=${conditions.join(" and ")}`;
    }

    RequestHandler.post(
      `/FirmAccount/ExportExcel`,
      { query },
      false
    ).then((response) => {
      hideMessage();

      if (response) {
        window.open(
          `${config.apiUrl}/FirmAccount/DownloadExcel?fileName=${response}&t=${RequestHandler.getToken()}`
        );
      }
    });
  };

  const columns = [
    {
      title: "Banka",
      dataIndex: "bankLogo",
      render: (text) => {
        return (
          <div style={{ width: 100 }}>
            {" "}
            <img src={text}></img>
          </div>
        );
      },
    },
    {
      title: "Cari Adı",
      dataIndex: "firmName",
      render: (text) => {
        if (!text) return;

        return (
          <Tooltip placement="topLeft" title={text}>
             {text.substring(0, 22).length < 22
              ? text.substring(0, 22) + ""
              : text.substring(0, 22) + "..."}
          </Tooltip>
        );
      },
    },
    {
        title: `Cari Kodu`,
        dataIndex: "firmBranchNumber",
        key: "firmBranchNumber",
        render: (text) => {
          if (!text) return "";

          return (
            <Tooltip title={text}>
              {text.substring(0, 22).length < 22
                ? text.substring(0, 22) + ""
                : text.substring(0, 22) + "..."}
            </Tooltip>
          );
        },
    },
    {
      title: "Tanım Adı",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Iban",
      dataIndex: "iban",
    },
    {
      title: "Hesap Numarası",
      dataIndex: "accountNumber",
      key: "accountNumber",
    },
    {
      title: "Banka Şubesi",
      dataIndex: "bankBranchName",
      key: "bankBranchName",
    },
    {
      title: "Para Birimi",
      dataIndex: "currency",
      key: "currency",
    },
    {
      title: "Güncelle",
      dataIndex: "id",
      align: "right",
      width: "10%",
      render: (data) => {

        if(tableDataQueryOptions.activeTab == 1) {
          return (
           <Tooltip title="TÖS Virman Hesapları Düzenlenemez"><EditOutlined style={{ color: "orange", fontSize: "130%", opacity:0.5, cursor:"not-allowed" }} /></Tooltip>
          )
        }
        return (
        <a
          onClick={() => {
            handleOnClickUpdate(data);
          }}
          style={{ color: "orange", fontSize: "130%" }}
        >
          <EditOutlined />
        </a>)
      },
    },
    {
      title: "Sil",
      dataIndex: "id",
      width: "1%",
      render: (data) => (
        <Popconfirm
          title="Silmek istiyor musunuz?"
          okText="Evet"
          cancelText="Hayır"
          onConfirm={() => handleOnClickDelete(data)}
        >
          <a style={{ color: "red", fontSize: "130%" }}>
            <DeleteOutlined />
          </a>
        </Popconfirm>
      ),
    },
  ];

    const onClearTableFilter = () => {
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      current: 1,
      filter: "",
    });
  };

  const onFinishTableFilter = (query) => {
    setTableDataQueryOptions((prevState) => {
      return {
        skip: 0,
        current: 1,
        take: prevState.take,
        filter: query,
      };
    });
  };

  return (
    <>
      {showBack &&  <Row style={{ marginBottom: 9 }}>
        <Col flex={1}>
          <a
            onClick={() => history.goBack()}
            style={{ color: "black", marginLeft: "4%" }}
          >
            {" "}
            <RollbackOutlined /> Geri Dön
          </a>
        </Col>
        <Col flex={4}></Col>
      </Row>}

      <Row>
        <Col xs={24} md={12} lg={14}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <BarsOutlined /> CARİ HESAPLARI
          </p>
        </Col>
        <Col xs={24} md={12} lg={10} style={{ textAlign: "right" }}>
          <Tooltip title="Excel İndir">
            <a
              style={{
                color: "green",
                fontSize: "180%",
                marginRight: 16,
              }}
              onClick={onClickExportExcel}
            >
              <FileExcelOutlined />
            </a>
          </Tooltip>
          <Button
            type="primary"
            onClick={() => setAddFormVisible(true)}
          >
            <PlusOutlined /> Cari Hesabı Ekle
          </Button>
        </Col>
      </Row>

      {
        isSendTosVirmanUnApproved ? <>      <Tabs
          defaultActiveKey={tableDataQueryOptions.activeTab}
          onChange={onTabChange}
        >
          <Tabs.TabPane tab="Cari Hesapları" key="0" />
          <Tabs.TabPane tab="TÖS Virman Hesapları" key="1" />
        </Tabs></> : <></>
      }



      <FirmAccountTableFilter
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        activeTab={tableDataQueryOptions.activeTab}
        style={{ marginTop: 12, marginBottom: 12 }}
      />

      <Row id="tableArea">
        <Col span={24}>
          <Table
            columns={columns}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{ overflowX: "auto", maxHeight: "100%" }}
            rowKey="id"
            filterable={true}
            size="small"
            sortable={true}
            pageable={true}
            onChange={paging}
            pagination={{
              defaultPageSize: tableDataQueryOptions.take,
              pageSizeOptions: ["15", "25", "50", "100"],
              total: tableData.total,
              current: tableDataQueryOptions.current,
            }}
            dataSource={tableData.data}
            loading={tableData.loading}
          />
        </Col>
      </Row>

      <Drawer
        id="addFirmAccountDrawer"
        title="Cari Hesabı Ekle"
        bodyStyle={{ padding: 24 }}
        width={500}
        onClose={() => {
          setAddFormVisible(false);
          form.resetFields();
        }}
        visible={addFormVisible}
      >
        <FirmAccountAddForm onSuccess={onAddFormSuccess} data={{ firmId: props.match.params.firmId }} isSendTosVirmanUnApproved={isSendTosVirmanUnApproved} form={form} activeTab={tableDataQueryOptions.activeTab}  />
      </Drawer>

      <Drawer
        id="updateFirmAccountDrawer"
        title="Cari Hesabı Güncelle"
        bodyStyle={{ padding: 24 }}
        width={500}
        onClose={() => {
          setUpdateFormVisible(false);
          form.resetFields();
        }}
        visible={updateFormVisible}
      >
        <FirmAccountUpdate
          data={updateFormData}
          onSuccess={onUpdateFormSuccess}
          isSendTosVirmanUnApproved= {isSendTosVirmanUnApproved}
          form={form}
        />
      </Drawer>
    </>
  );
};

export default FirmAccountList;
